import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { ToastComponent }      from './toast.component';
import { NavProgressComponent } from './nav-progress.component';
import { UserMenuComponent }   from '../user-menu/user-menu.component';
import { SideNavComponent }    from '../side-nav/side-nav.component';
import { LogBugWidgetComponent } from '../log-bug-widget/log-bug-widget.component';
import { FeedbackRatingComponent } from '../feedback-rating/feedback-rating.component';
import { ShellHeaderService, ShellAction, ShellBreadcrumb } from '../../services/shell-header.service';
import { PlatformIconComponent } from '../../../shared/components/platform-icon/platform-icon.component';

@Component({
  selector: 'sp-app-shell',
  standalone: true,
  imports: [CommonModule, RouterModule, ToastComponent, NavProgressComponent, UserMenuComponent, SideNavComponent, LogBugWidgetComponent, FeedbackRatingComponent, PlatformIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss'],
})
export class AppShellComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isHomePage   = false;
  actions:     ShellAction[]      = [];
  breadcrumb:  ShellBreadcrumb | null = null;

  constructor(
    private router:       Router,
    private shellHeader:  ShellHeaderService,
    private cdr:          ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // Detect current page on each navigation
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe((e: any) => {
        const url: string = e.urlAfterRedirects ?? e.url;
        this.isHomePage = url.endsWith('/home');
        this.cdr.markForCheck();
      });

    // Set initial value (before first NavigationEnd fires)
    this.isHomePage = this.router.url.endsWith('/home');

    this.shellHeader.actions$
      .pipe(takeUntil(this.destroy$))
      .subscribe(a => { this.actions = a; this.cdr.markForCheck(); });

    this.shellHeader.breadcrumb$
      .pipe(takeUntil(this.destroy$))
      .subscribe(b => { this.breadcrumb = b; this.cdr.markForCheck(); });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onBackClick(event: MouseEvent): void {
    event.preventDefault();
    if (this.breadcrumb?.backHandler) {
      this.breadcrumb.backHandler();
    } else {
      this.router.navigate(['/home']);
    }
  }

  runAction(action: ShellAction): void {
    action.handler();
  }
}
